import React from 'react';
import './textfield.css'
import { useFormContext } from 'react-hook-form';
import { ErrorMsg } from '../error-message';




const TextField = ({
    raised = false,
    darkMode = false,
    small = false,
    big = false,
    fluid = false,
    loading = false,
    readOnly = false,
    inputMode = "",
    placeholder = "",
    icon,
    name,
    type = "text",
    maxLength = 9999,
    avoidSpecialCharacter,
    value = "",
    isNumeric = false,
    className = '',
    onBlur = () => { }
}) => {

    const { register, formState: { errors } } = useFormContext()

    const validCharacters = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "Backspace",
        "ArrowLeft",
        "ArrowRight",
        "Tab"
    ]
    const handleKeyDown = (e) => {
        if (avoidSpecialCharacter && !avoidSpecialCharacter?.test(e.key)) {
            e.preventDefault()
        }
        if (isNumeric) {
            if (!validCharacters.includes(e.key)) {
                e.preventDefault()
            }
        }
    }

    return <div>
        <div className={`text-field ${className}  ${raised ? "text-field--raised" : ""} ${big ? "text-field--big" : ""} ${fluid ? "text-field--fluid" : ""} ${errors[name] ? "text-field--invalid" : ""} ${small ? "text-field--small" : ""}`}>
            {icon && <div className='text-field__icon'>{icon}</div>}
            <input
                type={type}
                id={name}
                {...register(name, {
                    onBlur: () => {
                        onBlur()
                    }
                })}
                inputMode={inputMode}
                defaultValue={value}
                maxLength={maxLength}
                placeholder={placeholder}
                onKeyDown={(e) => handleKeyDown(e)}
                readOnly={readOnly} />
            {loading && <div className='loadingAnimation'>
                <div></div>
                <div></div>
                <div></div>
            </div>}
        </div>
        <ErrorMsg errors={errors} name={name} darkMode />
    </div>;
}

export default TextField;
